const handleHero = () => {
  const headerSelector = '.header';
  const menuSelector = '.header__menu';
  const buttonSelector = '.header__button';
  const headerUnderlineSelector = '.header-underline';

  const menuToggleClass = 'header__menu--hidden';
  const buttonToggleClass = 'header__button--clicked';
  const headerUnderlineToggleClass = 'fade-out';

  const headerEl = document.querySelector(headerSelector);
  const menuEl = document.querySelector(menuSelector);
  const buttonEl = document.querySelector(buttonSelector);
  const headerUnderlineEl = document.querySelector(headerUnderlineSelector);

  const foundAllEl = headerEl != null && menuEl != null && buttonEl != null;
  if (foundAllEl) {
    const toggleMenu = () => {
      menuEl.classList.toggle(menuToggleClass);
      buttonEl.classList.toggle(buttonToggleClass);
      headerEl.classList.toggle('scroll');
      document.body?.classList.toggle('scroll');
    };

    buttonEl.addEventListener('click', toggleMenu);
  }

  const handleScrolling = () => {
    if (window.scrollY > 50) {
      headerUnderlineEl.classList.add(headerUnderlineToggleClass);
    } else {
      headerUnderlineEl.classList.remove(headerUnderlineToggleClass);
    }
  };

  window.addEventListener('scroll', handleScrolling);
};
export default handleHero;
